var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIconStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "place_review_statistics_path1",
    gradientUnits: "userSpaceOnUse",
    x1: 2.829,
    y1: 8.617,
    x2: 4.095,
    y2: 8.241,
    gradientTransform: "matrix(9.625 0 0 -7.112 -24.125 68.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00da90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3f9cee"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#place_review_statistics_path1)",
    d: "M3.4 8c.6 0 1 .4 1 1v2.6H1.8V9c0-.6.4-1 1-1h.6zm3.5-1.8c.6 0 1 .4 1 1v4.3H5.2V7.2c0-.6.4-1 1-1h.7zm3.5-1.8c.6 0 1 .4 1 1v6.1H8.8V5.4c0-.6.4-1 1-1h.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M.5 12h12.1c.3 0 .5.2.5.5s-.2.5-.5.5H.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5zM10.9.3V2.2c0 .2-.2.4-.4.4s-.5-.1-.5-.4v-.6c-1.9 2-4.4 3.2-7.3 3.7-.2.1-.5-.1-.5-.3 0-.2.1-.5.4-.5C5.4 4 7.7 2.8 9.5.9h-.8c-.2 0-.4-.2-.4-.5 0-.2.2-.4.4-.4h1.8-.1.2c.2.1.3.2.3.3z"
  })));
}
export default SvgReviewIconStatistics;